import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router";
import { motion } from "motion/react";
import { api, ApiError } from "../api.ts";
import { useAuth } from "../auth.tsx";
import { Button, ErrorText, Icon, Loading } from "../ui/index.tsx";
import { AuthLayout } from "../layouts.tsx";
import { authItem } from "./Login.tsx";

type State = { kind: "working" } | { kind: "ok" } | { kind: "error"; message: string };

export default function VerifyEmail() {
  const { token = "" } = useParams();
  const { me, refresh } = useAuth();
  const [state, setState] = useState<State>({ kind: "working" });
  // The token is single use, so a re-run of this effect (StrictMode in dev) must not post it twice.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    api.post("/auth/verify-email", { token })
      .then(() => { setState({ kind: "ok" }); return refresh().catch(() => {}); })
      .catch((e) => setState({ kind: "error", message: e instanceof ApiError ? e.message : "Couldn't verify this email. Try again." }));
  }, [token, refresh]);

  return (
    <AuthLayout title={state.kind === "ok" ? "Email verified" : state.kind === "error" ? "Link expired" : "Verifying your email"}
      subtitle={state.kind === "ok" ? "You can now use it to reset your password." : undefined}>
      {state.kind === "working" ? <Loading /> : (
        <motion.div variants={authItem} className="space-y-4" role="status">
          {state.kind === "ok" ? (
            <div className="flex items-center gap-3 rounded-lg border border-ok/30 bg-ok/10 px-3 py-3 text-sm text-ok">
              <Icon name="check" className="size-4 shrink-0" />
              <span>Your email address is confirmed.</span>
            </div>
          ) : <div role="alert"><ErrorText>{state.message}</ErrorText></div>}
          <Link to="/account"><Button variant="primary" size="lg" className="w-full">{me ? "Go to your account" : "Sign in to your account"}</Button></Link>
        </motion.div>
      )}
    </AuthLayout>
  );
}
